import axios from "axios";
import { getToken } from "../../../auth/authService";

const api = axios.create({
 baseURL: process.env.REACT_APP_BASE_URL,
 headers: {
 Authorization: `Bearer ${getToken()}`,
 "Content-Type": "application/json",
 },
});

/**
 * ===============================
 * ADMIN FAQ SERVICE
 * ===============================
 */

/**
 * Get all FAQs
 */
export const fetchAllFaqs = async () => {
 try {

 const response = await api.get("/admin/faqs");

 return {
 status: response.status,
 data: response.data,
 };

 } catch (err) {

 return {
 status: err.response?.status || 500,
 data: [],
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to fetch FAQs",
 };

 }
};

/**
 * Create FAQ
 */
export const createFaq = async (faq) => {
 try {

 const response = await api.post(
 "/admin/faqs",
 faq
 );

 return {
 status: response.status,
 data: response.data,
 message: "FAQ created successfully",
 };

 } catch (err) {

 return {
 status: err.response?.status || 500,
 data: null,
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to create FAQ",
 };

 }
};

/**
 * Update FAQ
 */
export const updateFaq = async (id, faq) => {
 try {

 const response = await api.put(
 `/admin/faqs/${id}`,
 faq
 );

 return {
 status: response.status,
 data: response.data,
 message: "FAQ updated successfully",
 };

 } catch (err) {

 return {
 status: err.response?.status || 500,
 data: null,
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to update FAQ",
 };

 }
};

/**
 * Delete FAQ
 */
export const deleteFaq = async (id) => {
 try {

 const response = await api.delete(
 `/admin/faqs/${id}`
 );

 return {
 status: response.status,
 message: "FAQ deleted successfully",
 };

 } catch (err) {

 return {
 status: err.response?.status || 500,
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to delete FAQ",
 };

 }
};